export enum CurrencyOptionEnum {
  local = 'local',
  foreign = 'foreign',
}
